/* eslint-disable indent */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Button } from 'react-bootstrap'
import { Guides, IssueResolvedModal, ContentFilter } from '..'
import messages from './messages'
import LanguageProvider from '../../containers/LanguageProvider/LanguageProvider'
import {
  RelatedSidebarContainer,
  ContactUsModalContainer
} from '../../containers'
import styled from 'styled-components'
import SEO from '../SEO'
import {
  createSteps,
  createStructuredData,
  iterate,
  trimString
} from '../../helpers/utils'
import { ASSETS_URL } from '../../constants/urls'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const ResolvedBar = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap-reverse;
  gap: 10px;

  @media (max-width: 768px) {
    justify-content: center;
  }
`
class SingleGuide extends Component {
  state = {
    previousGuide: [],
    showResolvedModal: false,
    showContactModal: false
  }

  static contextTypes = {
    router: PropTypes.shape({
      replace: PropTypes.func
    })
  }

  static propTypes = {
    relatedType: PropTypes.string.isRequired,
    preSaleFlag: PropTypes.bool.isRequired,
    activeGuide: PropTypes.shape({
      val: PropTypes.number,
      text: PropTypes.string
    }),
    query: PropTypes.object.isRequired,
    createUserEvent: PropTypes.func.isRequired,
    language: PropTypes.string.isRequired,
    currentPhone: PropTypes.shape({
      id: PropTypes.number,
      os: PropTypes.string,
      manufacturer: PropTypes.string,
      name: PropTypes.string
    }).isRequired,
    relatedData: PropTypes.string,
    suggested: PropTypes.string,
    hideContactButton: PropTypes.string
  }

  constructor(props) {
    super(props)
    this.state = { ...this.state, guide: props.activeGuide }
    this.renderSingleGuide = this.renderSingleGuide.bind(this)
    this.clickNext = this.clickNext.bind(this)
    this.clickBack = this.clickBack.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.openModal = this.openModal.bind(this)
  }

  componentWillUpdate(nextProps, nextState) {
    const { showResolvedModal, showContactModal, guide } = this.state
    const { activeGuide, suggested, relatedData } = this.props

    if (activeGuide !== nextProps.activeGuide) {
      this.setState({ guide: nextProps.activeGuide, previousGuide: [] })
    }

    if (guide === undefined || guide === null) {
      return
    }

    const shouldAnimate =
      showResolvedModal === nextState.showResolvedModal &&
      suggested === nextProps.suggested &&
      showContactModal === nextState.showContactModal &&
      relatedData === nextProps.relatedData

    if (shouldAnimate) {
      const element = document.querySelector('.trouble-step-text')
      if (!element) { return }
      element.classList.remove('fadeIn')
      void element.offsetWidth
      element.classList.add('fadeIn')
    }
  }

  closeModal(property) {
    this.setState({
      [property]: false
    })
  }

  openModal(property, guideVal) {
    const { createUserEvent } = this.props
    property === 'showContactModal' &&
      createUserEvent({
        category: 'navigation',
        data: {
          link_to: '#contact',
          source: 'ContactMainGuideSupport'
        }
      })
    property === 'showResolvedModal' &&
      createUserEvent({
        category: 'guides',
        data: {
          action: 'GuideResolveSuccess',
          target: guideVal
        }
      })
    this.setState({
      [property]: true
    })
  }

  clickNext(guide, previousGuide) {
    const previousGuideArr = this.state.previousGuide
    const { createUserEvent } = this.props
    createUserEvent({
      category: 'guides',
      data: {
        action: 'GuideNextStep',
        target: guide.val
      }
    })
    previousGuideArr.push(previousGuide)
    this.setState({
      guide,
      previousGuide: previousGuideArr
    })
  }

  clickBack() {
    const { previousGuide} = this.state
    const { createUserEvent } = this.props
    const { router } = this.props

    if (previousGuide.length === 0) {
      router.push({
        pathname: '/guides',
        query: this.props.query
      })
      createUserEvent({
        category: 'guides',
        data: {
          action: 'GuideStepBack',
          target: 'root'
        }
      })
    } else {
      const newGuide = previousGuide[previousGuide.length - 1]
      createUserEvent({
        category: 'guides',
        data: {
          action: 'GuideStepBack',
          target: newGuide.val
        }
      })
      previousGuide.pop()
      this.setState({
        guide: newGuide,
        previousGuide
      })
    }
  }

  renderResolvedBar(showResolved, guide, translated) {
    return (
      (showResolved || !this.props.hideContactButton) && (
        <div className="resolved-next">
            <span>
              {`${showResolved ? translated.resolved : translated.support}`}
            </span>
            <Choose>
              <When condition={showResolved}>
                <div className="btn-custom-toolbar">
                  <Button
                    className="btn-resolve"
                    onClick={this.openModal.bind(
                      this,
                      'showResolvedModal',
                      guide.val
                    )}
                  >
                    {translated.yes}
                  </Button>
                  <Button
                    className="btn-resolve"
                    onClick={this.clickNext.bind(
                      null,
                      guide.children[0],
                      guide
                    )}
                  >
                    {translated.no}
                  </Button>
                </div>
              </When>
              <Otherwise>
                <Button
                  className="btn-resolve"
                  onClick={this.openModal.bind(
                    this,
                    'showContactModal',
                    guide.val
                  )}
                >
                  {translated.help}
                </Button>
              </Otherwise>
            </Choose>
          </div>
      )
    )
  }

  renderText(guide) {
    const children = guide.children[0]
    return (
      <div style={{ marginBottom: '20px' }}>
        <ContentFilter text={children.text} name={this.props.currentPhone && this.props.currentPhone.name_pretty} />
      </div>
    )
  }

  renderSingleGuide(guide, translated) {
    const { activeGuide } = this.props
    return (
      <Wrapper className="trouble-step-text animated fadeIn">
        <p style={{ fontSize: '1.25em', fontWeight: 'bold', color: 'var(--clr-accent)' }}>{activeGuide.text}</p>
        <div>
          {this.renderText(guide, translated)}
          <div className="guide-clear" />
        </div>
        <RelatedSidebarContainer
          contentType="guide"
          relatedType="suggested"
          id={guide.val}
        />
        <ResolvedBar className="resolved-bar">
          <div className="resolved-back">
            <Button className="btn-back" onClick={this.clickBack}>
              {translated.back}
            </Button>
          </div>
          {this.renderResolvedBar(
            guide.children[0].children.length > 0,
            guide,
            translated
          )}
        </ResolvedBar>
      </Wrapper>
    )
  }

  render() {
    const {
      currentPhone,
      relatedType,
      preSaleFlag,
      language,
      createUserEvent,
      activeGuide,
      router
    } = this.props

    const { guide, showResolvedModal, showContactModal } = this.state
    const translated = messages[language]
    const text = (activeGuide && activeGuide.children[0].text) || ''
    const description = trimString(text, 120)
    const imageURL =
    currentPhone && currentPhone.image_location
      ? `${ASSETS_URL}${currentPhone &&
        currentPhone.image_location}`
      : ''
    const steps = iterate()
    let stepText = []

    if (activeGuide && activeGuide.children.length > 0) {
      stepText = steps(activeGuide.children[0], 'text')
    }

    const stepT = createSteps(stepText, "text")

    if (guide === undefined && activeGuide === null) {
      // fall back to the last parent container
      router.replace({
        pathname: '/guides',
        query: this.props.query
      })
    }

    if (!activeGuide) {
      return <div>Loading...</div>
    }
    return (
      <Guides
        noSideBar={preSaleFlag}
        noSearchBar={preSaleFlag}
        currentPhone={currentPhone}
        relatedType={relatedType}
        createUserEvent={createUserEvent}
        relatedId={activeGuide.val}
        name={`${activeGuide.text}`}
      >
        <SEO
          title={`${activeGuide.text} | ${currentPhone &&
            currentPhone.name_pretty}`}
          image={imageURL}
          description={description}
          script={createStructuredData(activeGuide.text, currentPhone.name_pretty, imageURL, stepT) }
        />
        {guide && this.renderSingleGuide(guide, translated, createUserEvent)}
        <IssueResolvedModal
          show={showResolvedModal}
          onHide={this.closeModal.bind(this, 'showResolvedModal')}
        />
        <ContactUsModalContainer
          onHide={this.closeModal.bind(this, 'showContactModal')}
          help
          show={showContactModal}
        />
      </Guides>
    )
  }
}

export default LanguageProvider(SingleGuide)



// WEBPACK FOOTER //
// ./src/components/SingleGuide/SingleGuide.js